import numberFormat from "./number-format";

export default {
  'number-format': numberFormat
}